import { HoroscopeType, StringType } from '@/App/types';

export const getHoroscopeType = (value: StringType | undefined): HoroscopeType | null => {
  if (!value) {
    return null;
  }

  return HoroscopeType[value];
};
